var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.snippet && _vm.count)?_c('div',[_c('em',{staticClass:"text-gray-metadata italic"},[_vm._v(_vm._s(_vm.countDisplay))]),_vm._v(" "),_c('MarkdownElement',{staticClass:"block text-theme snippet",attrs:{"body":_vm.displaySnippet}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }